import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ImagesList = () => {
    const [image, setImage] = useState('');
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState('');

    function handleImage(e) {
        setImage(e.target.files[0]);
    }

    function handleApi() {
        if (!image) {
            toast.error('Please select an image first', {
                position: 'top-right',
                autoClose: 1500,
                theme: 'colored',
            });
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append('mypic', image);
        const url = process.env.REACT_APP_API_URL + 'images/uploadImage';
        
        axios.post(url, formData).then((res) => {
            setImage('');
            setUploading(false);
            document.querySelector('input[type="file"]').value = "";
            toast.success('Image uploaded successfully', {
                position: 'top-right',
                autoClose: 1500,
                theme: 'colored',
            });
            setPage(1);
            fetchImages();
        }).catch((err) => {
            setUploading(false);
            toast.error('Failed to upload image', {
                position: 'top-right',
                autoClose: 1500,
                theme: 'colored',
            });
        });
    }

    const fetchImages = async () => {
        setLoading(true);
        const url = `${process.env.REACT_APP_API_URL}images/allimages?page=${page}&limit=10&search=${searchTerm}`;
        const headers = {
            'x-access-token': localStorage.getItem('jwttoken')
        };

        try {
            const response = await axios.get(url, { headers });
            setImages(response.data.data || []);
            setTotalPages(response.data.totalPages || 1);
        } catch (err) {
            console.error('Error fetching images:', err);
            toast.error('Failed to fetch images', {
                position: 'top-right',
                autoClose: 1500,
                theme: 'colored',
            });
        } finally {
            setLoading(false);
        }
    }

    const confirmDelete = (filename) => {
        setDeleteTarget(filename);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        setShowDeleteModal(false);
        const url = `${process.env.REACT_APP_API_URL}images/delete/${deleteTarget}`;
        const headers = {
            'x-access-token': localStorage.getItem('jwttoken')
        };

            try {
                await axios.delete(url, { headers });
                toast.success('Image deleted successfully', {
                    position: 'top-right',
                    autoClose: 1500,
                    theme: 'colored',
                });
                fetchImages();
            } catch (err) {
                toast.error('Failed to delete image', {
                    position: 'top-right',
                    autoClose: 1500,
                    theme: 'colored',
            });
        }
    };

    useEffect(() => {
        fetchImages();
    }, [page, searchTerm]);

    return (
        <div>
            <ToastContainer />

            {/* Main Card Container */}
            <div className='main-card'>

                {/* Toolbar Section */}
                <div className='toolbar-container'>
                    <h2 className='page-title'>Images Management</h2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span className='results-count'>{images.length} results</span>
                        <input
                            type='text'
                            className='search-box'
                            placeholder='Search Image by Name...'
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1);
                            }}
                        />
                    </div>
                </div>

                {/* Upload Section */}
                <div className='upload-section'>
                    <div className='upload-input-group'>
                        <input 
                            type='file' 
                            onChange={handleImage} 
                            className='form-control' 
                            accept='image/*'
                        />
                        <button 
                            onClick={handleApi} 
                            className='btn-add-primary'
                            disabled={!image || uploading}
                        >
                            {uploading ? 'Uploading...' : '↑ Upload Image'}
                        </button>
                    </div>
                </div>

                {/* Gradient Header */}
                <div className='table-header-panel'>
                    Images List
                </div>

                {/* Grid/Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className='custom-table'>
                        <thead>
                            <tr>
                                <th style={{ width: '60px' }}>SR No.</th>
                                <th>Preview</th>
                                <th>File Name</th>
                                <th style={{ width: '100px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan='4'>
                                        <div className='loading-container'>
                                            <div className='spinner'></div>
                                        </div>
                                    </td>
                                </tr>
                            ) : images.length === 0 ? (
                                <tr>
                                    <td colSpan='4'>
                                        <div className='empty-state'>
                                            <div className='empty-state-icon'>🖼️</div>
                                            <div className='empty-state-text'>No images found</div>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                images.map((item, index) => (
                                    <tr key={index}>
                                        <td>{(page - 1) * 10 + index + 1}</td>
                                        <td>
                                            <img 
                                               src={process.env.REACT_APP_IMAGE_URL + item}
                                                alt='' 
                                                className='table-img'
                                                loading="lazy"
                                            />
                                        </td>
                                        <td style={{ fontWeight: '600' }}>{item}</td>
                                        <td>
                                            <button 
                                                onClick={() => confirmDelete(item)}
                                                className='btn-action-delete'
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination Controls */}
                <div style={{ marginTop: "20px", textAlign: "center", paddingBottom: "20px" }}>
                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                        className="btn-pagination"
                    >
                        Prev
                    </button>

                    <select
                        value={page}
                        onChange={(e) => setPage(Number(e.target.value))}
                        style={{ margin: "0 10px", padding: "5px" }}
                    >
                        {Array.from({ length: totalPages }, (_, i) => (
                            <option key={i + 1} value={i + 1}>Page {i + 1}</option>
                        ))}
                    </select>

                    <span> of {totalPages} </span>

                    <button
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                        className="btn-pagination"
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* Deletion Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the image <strong>{deleteTarget}</strong>?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ImagesList;
